"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5442],{

/***/ 95442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44541);
/* harmony import */ var _utils_commonToggleAuthModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13605);
/* harmony import */ var _utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(86423);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49784);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(19372);
/* harmony import */ var _SubscriberInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56695);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79570);
/* harmony import */ var _utils_isClickOutside__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(53569);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13886);
/* harmony import */ var _components_LogoutModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21448);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86812);
/* harmony import */ var _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85126);
/* harmony import */ var _components_FooterMap_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76364);
/* harmony import */ var _hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27560);
/* harmony import */ var _footerUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62371);
/* harmony import */ var _utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(18626);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26706);
/* harmony import */ var _hooks_useStoreLogoOrNameVisibility__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73323);
/* harmony import */ var _utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68491);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99375);


























var MAX_CATEGORIES_ITEMS = 20;
var Footer = function(props) {
    var getCurrentYear = function getCurrentYear() {
        return new Date().getFullYear() || "";
    };
    var handleToggleMoreCategories = function handleToggleMoreCategories() {
        setToggleMoreCategories(!toggleMoreCategories);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderLoginLogoutDesktop = function renderLoginLogoutDesktop() {
        return headerName === "Header14" ? isLoginVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "footer-nav mb3 fw6",
            onClick: toggleAuthModal,
            children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
        }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "footer-nav mb3 fw6",
            onClick: toggleAuthModal,
            children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
        });
    };
    var renderLoginLogoutMobile = function renderLoginLogoutMobile() {
        return headerName === "Header14" ? isLoginVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    style: {
                        fontSize: 14
                    },
                    onClick: toggleAuthModal,
                    children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                })
            ]
        }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    style: {
                        fontSize: 14
                    },
                    onClick: toggleAuthModal,
                    children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                })
            ]
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return showLogoutConfirmation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LogoutModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
            toggleLogoutModal: toggleLogoutModal,
            executeLogout: _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_11__/* .executeLogout */ .q,
            showLogoutConfirmation: showLogoutConfirmation
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), shopName = ref17[0], setShopName = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), categories = ref18[0], setCategories = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), navItems = ref19[0], setNavItems = ref19[1];
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), toggleMoreCategories = ref20[0], setToggleMoreCategories = ref20[1];
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(MAX_CATEGORIES_ITEMS), mobileCategoriesLength = ref21[0], setMobileCategoriesLength = ref21[1];
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showLogoutConfirmation = ref22[0], setShowLogoutConfirmation = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shopOpen = ref23[0], toggleShop = ref23[1];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), collectionIdOpen = ref24[0], setCollectionIdOpen = ref24[1];
    var ref25 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            user: state.userReducer,
            paymentMethods: state.paymentReducer.availablePaymentMethods
        };
    }), user = ref25.user, paymentMethods = ref25.paymentMethods;
    var ref26 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_15__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            storePolicies: state.storePolicyReducer.data,
            collections: state.catalogReducer.collections,
            navigationList: state.additionalPagesReducer.navigationList,
            catalogCategories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags
        };
    }), storeData = ref26.storeData, navigationList = ref26.navigationList, storePolicies = ref26.storePolicies, collections = ref26.collections, catalogCategories = ref26.catalogCategories, productTags = ref26.productTags;
    var ref27 = (0,_hooks_useStoreLogoOrNameVisibility__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(), isStoreLogoInFooter = ref27.isStoreLogoInFooter, isStoreNameInFooter = ref27.isStoreNameInFooter;
    var storeLogo = (0,_utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(storeData);
    var ref28 = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(), storeAddress = ref28.storeAddress, storePhone = ref28.storePhone, storeEmail = ref28.storeEmail;
    var ref29 = (0,_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_13__/* .useFeatureLocks */ .r)(), leadGenFeatureStatus = ref29.leadGenFeatureStatus, visitorLoginFeatureStatus = ref29.visitorLoginFeatureStatus;
    var isLeadGenVisible = leadGenFeatureStatus === null || leadGenFeatureStatus === void 0 ? void 0 : leadGenFeatureStatus.isVisible;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var headerName = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name;
    var isLoginVisible = props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.login_view;
    var dsLabel = (0,_footerUtils__WEBPACK_IMPORTED_MODULE_14__/* .getFooterDSLabel */ .m)(storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.theme) === null || ref6 === void 0 ? void 0 : ref6.components);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .MAX_MOBILE_WIDTH */ .Cf) document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user.isLogin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 766) {
            toggleShop(false);
        } else {
            toggleShop(true);
        }
    }, [
        _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        toggleMoreCategories ? setMobileCategoriesLength(categories.length) : setMobileCategoriesLength(MAX_CATEGORIES_ITEMS);
    }, [
        toggleMoreCategories
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setCategories((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(productTags).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(catalogCategories)));
    }, [
        productTags,
        catalogCategories
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setNavItems([]);
        var tempNavList = [];
        navigationList.map(function(nav) {
            if (nav.slug_url === "shop") {
                setShopName(nav.page_name);
            } else {
                tempNavList.push(nav);
            }
        });
        setNavItems(tempNavList);
    }, [
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_20__/* .getStorePolicies */ .S)({
                store_id: storeData.store_id
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_21__/* .getAvailablePaymentMethods */ .fj)({
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    var handleClickOutside = function(e) {
        if (!(0,_utils_isClickOutside__WEBPACK_IMPORTED_MODULE_22__/* .isOutsideClick */ .W)(ref16, e.target)) {
            setToggleMoreCategories(false);
        }
    };
    var hidePaymentMethod = function(paymentMethod) {
        switch(paymentMethod.payment_id){
            case "paytm":
            case "amexCard":
                return true;
            default:
                return false;
        }
    };
    var toggleShopDropdown = function() {
        if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 766) {
            toggleShop(!shopOpen);
        }
    };
    var handleNavbarItemClick = function(nav) {
        nav.is_editable ? (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_7__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.additionalPage(nav.slug_url)) : (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_7__/* .handleRouteChangesOnClick */ .Z)(nav.slug_url);
    };
    var renderNavType = function(nav) {
        switch(nav.page_type){
            case "more":
                {
                    var ref;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "footer-nav mb3",
                        onClick: function() {
                            return handleNavbarItemClick(nav);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                nav.page_name,
                                (nav === null || nav === void 0 ? void 0 : (ref = nav.subNavs) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: "dropdown button",
                                    src: "/assets/images/angleright.png"
                                })
                            ]
                        })
                    }, nav.page_id);
                }
            case "blank_page":
                {
                    return nav.is_external_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "footer-nav mb3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            style: {
                                color: "#000000",
                                fontSize: 14
                            },
                            className: "link",
                            href: nav.slug_url,
                            target: "_blank",
                            rel: "noreferrer",
                            children: nav.page_name
                        })
                    }, nav.page_id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "footer-nav mb3",
                        onClick: function() {
                            return handleNavbarItemClick(nav);
                        },
                        children: nav.page_name
                    }, nav.page_id);
                }
            default:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "footer-nav mb3",
                        onClick: function() {
                            return handleNavbarItemClick(nav);
                        },
                        children: nav.page_name
                    }, nav.page_id);
                }
        }
    };
    var onCategoryClick = function(category) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        if (next_router__WEBPACK_IMPORTED_MODULE_3___default().router.pathname.includes("/shop")) window.scrollTo(0, 0);
        if ((0,_utils_isPLPRequiredSystem__WEBPACK_IMPORTED_MODULE_23__/* .isPLPRequiredSystem */ .q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            next_router__WEBPACK_IMPORTED_MODULE_3___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain), undefined, {
                shallow: true
            });
        } else {
            var ref2;
            next_router__WEBPACK_IMPORTED_MODULE_3___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("".concat(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
    };
    var toggleAuthModal = function() {
        var ref;
        if ((0,_utils_commonToggleAuthModal__WEBPACK_IMPORTED_MODULE_5__/* .commonToggleAuthModal */ .D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain
        })) toggleLogoutModal();
    };
    var collectionToggle = function() {
        if (shopOpen) setCollectionIdOpen(null);
        toggleShop(!shopOpen);
    };
    var collectionDropdownToggle = function(colId) {
        if (collectionIdOpen === colId) setCollectionIdOpen(null);
        else setCollectionIdOpen(colId);
    };
    var onCollectionClick = function(id) {
        var ref;
        next_router__WEBPACK_IMPORTED_MODULE_3___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.collectionCategories(id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var renderDesktopCategories = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-row justify-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "store-information desktop-hr",
                    children: shopOpen && (categories === null || categories === void 0 ? void 0 : categories.map(function(item, index) {
                        return index % 2 === 0 && index < MAX_CATEGORIES_ITEMS ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "footer-nav mb3",
                            onClick: function() {
                                return onCategoryClick(item);
                            },
                            children: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_24__/* .removeEmoticons */ ._)(item.name) || "Available Items"
                        }, item.id) : null;
                    }))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "store-information ml4 desktop-hr",
                    children: [
                        shopOpen && (categories === null || categories === void 0 ? void 0 : categories.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: index % 2 !== 0 && index < MAX_CATEGORIES_ITEMS - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "footer-nav mb3",
                                    onClick: function() {
                                        return onCategoryClick(item);
                                    },
                                    children: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_24__/* .removeEmoticons */ ._)(item.name) || "Available Items"
                                }, item.id) : null
                            });
                        })),
                        (categories === null || categories === void 0 ? void 0 : categories.length) >= MAX_CATEGORIES_ITEMS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "desc-text__view-more fw5 pointer underline-hover desktop-hr mv0 relative",
                            onClick: handleToggleMoreCategories,
                            children: [
                                "More...",
                                toggleMoreCategories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "store-information_arrowBox store-information_arrowBox_shadow z-5"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: ref16,
                                            className: "z-5 store-information store-information_arrow ph3 shadow-3 pt3 overflow-y-auto overflow-x-hidden",
                                            children: categories === null || categories === void 0 ? void 0 : categories.map(function(item, index) {
                                                return index >= MAX_CATEGORIES_ITEMS - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "footer-nav mb3 fw4",
                                                    onClick: function(e) {
                                                        return onCategoryClick(item, e);
                                                    },
                                                    children: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_24__/* .removeEmoticons */ ._)(item.name) || "Available Items"
                                                }, item.id) : null;
                                            })
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var renderMobileCategories = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-100",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "store-information mobile-hr-shop",
                    children: shopOpen && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && ((ref = categories === null || categories === void 0 ? void 0 : categories.slice(0, mobileCategoriesLength)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "footer-nav mb3",
                            onClick: function() {
                                return onCategoryClick(item);
                            },
                            children: (0,_utils_emoticonsStatus__WEBPACK_IMPORTED_MODULE_24__/* .removeEmoticons */ ._)(item.name) || "Available Items"
                        }, item.id);
                    }))
                }),
                (categories === null || categories === void 0 ? void 0 : categories.length) >= MAX_CATEGORIES_ITEMS && shopOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "desc-text__view-more fw5 pointer underline-hover mobile-hr-shop mt0 mb3",
                    onClick: handleToggleMoreCategories,
                    children: toggleMoreCategories ? "Show Less..." : "More..."
                })
            ]
        });
    };
    /**
   * Checks if given value is hidden or not
   * @param {*} visibilityValue
   * @return {boolean} hidden or visible
   */ var addressVisibilityHidden = function(visibilityValue) {
        var ref;
        return (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === visibilityValue;
    };
    /**
   * Store Policy and footer component
   * @return {JSX}
   */ var StorePolicyAndFooterBottomSection = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === (_utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === null || _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY.VISIBLE */ .lE.VISIBLE) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "Footer3__bottom-section flex flex-column items-center",
                    children: [
                        storePolicies.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "Footer3__section store-policies flex justify-around w-100 f6",
                            children: storePolicies.map(function(page) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    name: "page".concat(page.page_type),
                                    className: "footer-nav",
                                    onClick: function() {
                                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_7__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.STORE_POLICIES, {
                                            page_type: page.page_type
                                        });
                                    },
                                    children: page.page_name
                                }, page.id);
                            })
                        }),
                        !(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hidden_components) === null || ref2 === void 0 ? void 0 : ref2.payment_method_images_not_visible) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                display: "none"
                            },
                            className: "payment-methods mt3 flex items-center",
                            children: paymentMethods.length > 0 && paymentMethods.map(function(paymentMethod, index) {
                                if (hidePaymentMethod(paymentMethod) || paymentMethod.status == 0) {
                                    return null;
                                } else {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: "payment menthod ".concat(index + 1),
                                        src: paymentMethod.image_url,
                                        className: "mr3 mb0-ns mb3",
                                        height: "18px"
                                    }, paymentMethod.image_url);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "footer__bottom-text",
                            children: [
                                "Copyright ",
                                getCurrentYear(),
                                dsLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        ". ",
                                        dsLabel
                                    ]
                                }) : ""
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var NavigationComponent = function() {
        if (collections === null || collections === void 0 ? void 0 : collections.length) return null;
        return (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-column f6 ttc w-30",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                    className: "pointer",
                    onClick: toggleShopDropdown,
                    children: [
                        shopName || "Shop",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "right-2 absolute dn-ns",
                            width: "8px",
                            alt: "dropdown button",
                            src: "/assets/images/angleright.png",
                            style: {
                                transform: shopOpen ? "rotate(-90deg)" : "rotate(90deg)"
                            }
                        })
                    ]
                }),
                _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 767 ? renderMobileCategories() : renderDesktopCategories(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                })
            ]
        });
    };
    /**
   * collections listing component for desktop only
   * if collection is not part of store config
   * it is not renderred
   * @return {null | JSX}
   */ var DesktopCollectionsComponent = function() {
        if (!(props === null || props === void 0 ? void 0 : props.includeCollectionSet) || collections.length === 0) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "Footer3__collections-component",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "collections-component--header",
                    children: "Collection"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "collections-component__body",
                    children: (collections === null || collections === void 0 ? void 0 : collections.length) ? collections.map(function(collection) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "collection-item",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "collection-item--header pointer",
                                    onClick: function() {
                                        return onCollectionClick(collection.id);
                                    },
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "collection-item__item-list",
                                    children: (collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.length) ? collection === null || collection === void 0 ? void 0 : collection.categories.map(function(category) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "collection-item--name",
                                            onClick: function() {
                                                return onCategoryClick(category);
                                            },
                                            children: category.name
                                        }, category.id);
                                    }) : null
                                })
                            ]
                        }, collection.id);
                    }) : null
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
            ]
        });
    };
    var MobileCollectionsComponent = function() {
        if (!(props === null || props === void 0 ? void 0 : props.includeCollectionSet) || (collections === null || collections === void 0 ? void 0 : collections.length) === 0) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "accordion-component",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                            className: "accordion-header fw6",
                            onClick: collectionToggle,
                            children: [
                                "Shop",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "ml3",
                                    width: "8px",
                                    alt: "dropdown button",
                                    src: "/assets/images/angleright.png",
                                    style: {
                                        transform: "rotate(".concat(shopOpen ? "270deg" : "90deg", ")")
                                    }
                                })
                            ]
                        }),
                        shopOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: (collections === null || collections === void 0 ? void 0 : collections.length) ? collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "accordion-body",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "accordion-header fw5 ttu",
                                            onClick: function() {
                                                return collectionDropdownToggle(collection.id);
                                            },
                                            children: [
                                                collection.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: "ml3",
                                                    width: "8px",
                                                    alt: "dropdown button",
                                                    src: "/assets/images/angleright.png",
                                                    style: {
                                                        transform: "rotate(".concat(collectionIdOpen === collection.id ? "270deg" : "90deg", ")")
                                                    }
                                                })
                                            ]
                                        }),
                                        collectionIdOpen === collection.id && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            children: (collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.length) ? collection === null || collection === void 0 ? void 0 : (ref1 = collection.categories) === null || ref1 === void 0 ? void 0 : ref1.map(function(category) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    onClick: function() {
                                                        return onCategoryClick(category);
                                                    },
                                                    children: category.name
                                                }, category.id);
                                            }) : null
                                        })
                                    ]
                                }, collection.id);
                            }) : null
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "mobile-hr"
                })
            ]
        });
    };
    var RenderSocialMediaProfileDetails = function() {
        var ref, ref1, ref2;
        if (!((ref = storeData.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = storeData.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer-social-media-container",
            style: {
                width: "246px",
                marginBottom: "1rem"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "social-media-section flex space-between",
                    children: (ref2 = storeData.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "social-media-icon",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image")
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var FooterBottomComponent = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "store-information mt-13",
            children: [
                isLeadGenVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "store-information__subsection justify-start-ns justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SubscriberInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                }) : null,
                storeAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            children: "Visit our store"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "address-text fw4 f6",
                            children: storeAddress
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !!storeEmail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "store-information__subsection justify-start-ns justify-center",
                            style: {
                                marginTop: 40
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: "mail",
                                        src: "https://cdn.dotpe.in/kiranaStatic/icons/mail.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:".concat(storeEmail),
                                    className: "address-text fw4 f6",
                                    children: storeEmail
                                })
                            ]
                        }),
                        !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "store-information__subsection justify-start-ns justify-center",
                            style: {
                                marginTop: storeEmail ? 10 : 40
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: "phone",
                                        src: "https://cdn.dotpe.in/kiranaStatic/icons/ringingtelephone.png"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "tel:".concat(storePhone),
                                    className: "address-text fw4 f6",
                                    children: storePhone
                                })
                            ]
                        })
                    ]
                }),
                (storeData === null || storeData === void 0 ? void 0 : storeData.social_media_profile_details) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderSocialMediaProfileDetails, {})
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
                className: "Footer3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "Footer3__top-section",
                        style: {
                            maxWidth: addressVisibilityHidden(_utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === null || _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY.HIDDEN */ .lE.HIDDEN) ? "1200px" : "100%",
                            padding: addressVisibilityHidden(_utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === null || _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY */ .lE === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .ADDRESS_VISIBILITY.HIDDEN */ .lE.HIDDEN) ? "0 2rem" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FooterMap_index__WEBPACK_IMPORTED_MODULE_12__/* .FooterMap3 */ .IA, {
                                storeData: storeData
                            }),
                            !((next_router__WEBPACK_IMPORTED_MODULE_3___default()) === null || (next_router__WEBPACK_IMPORTED_MODULE_3___default()) === void 0 ? void 0 : (ref7 = (next_router__WEBPACK_IMPORTED_MODULE_3___default().router)) === null || ref7 === void 0 ? void 0 : ref7.pathname.includes(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.ABOUT_US)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "Footer3__section tc footer-shop-desc",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-mb-5 tw-flex tw-flex-col tw-items-center tw-gap-5",
                                        children: [
                                            storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: storeLogo,
                                                height: "67",
                                                width: "67",
                                                alt: "store logo"
                                            }),
                                            isStoreNameInFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "tw-m-0",
                                                children: storeData === null || storeData === void 0 ? void 0 : (ref8 = storeData.store_info) === null || ref8 === void 0 ? void 0 : ref8.name
                                            })
                                        ]
                                    }),
                                    (!!(storeData === null || storeData === void 0 ? void 0 : (ref9 = storeData.store_info) === null || ref9 === void 0 ? void 0 : ref9.description) || (storeData === null || storeData === void 0 ? void 0 : (ref10 = storeData.store_info) === null || ref10 === void 0 ? void 0 : ref10.description.length) > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bottom-section",
                                        children: (storeData === null || storeData === void 0 ? void 0 : (ref11 = storeData.store_info) === null || ref11 === void 0 ? void 0 : ref11.description.length) > 160 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "desc-text",
                                            children: [
                                                storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.store_info) === null || ref12 === void 0 ? void 0 : ref12.description.substr(0, 160),
                                                "..."
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "desc-text",
                                            children: storeData === null || storeData === void 0 ? void 0 : (ref13 = storeData.store_info) === null || ref13 === void 0 ? void 0 : ref13.description
                                        })
                                    }),
                                    (storeData === null || storeData === void 0 ? void 0 : (ref14 = storeData.store_info) === null || ref14 === void 0 ? void 0 : ref14.description.length) > 160 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "desc-text__view-more fw5 pointer underline-hover",
                                        onClick: function() {
                                            return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_7__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.ABOUT_US);
                                        },
                                        children: "View More"
                                    })
                                ]
                            }),
                            _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o >= 787 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopCollectionsComponent, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "mobile-hr"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "Footer3__section flex justify-evenly center w-80",
                                children: [
                                    (navItems === null || navItems === void 0 ? void 0 : navItems.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-column f6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: storeData === null || storeData === void 0 ? void 0 : (ref15 = storeData.store_info) === null || ref15 === void 0 ? void 0 : ref15.name
                                            }),
                                            navItems.map(function(nav) {
                                                return renderNavType(nav);
                                            }),
                                            _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o > 767 && isVisitorLoginVisible && renderLoginLogoutDesktop()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavigationComponent, {}),
                                    !props.includeCollectionSet && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 767 && isVisitorLoginVisible && renderLoginLogoutMobile(),
                                    _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 786 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileCollectionsComponent, {}),
                                    props.includeCollectionSet && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o < 767 && isVisitorLoginVisible && renderLoginLogoutMobile(),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterBottomComponent, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StorePolicyAndFooterBottomSection, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 62371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getFooterDSLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getFooterDSLabel = function(componentsList) {
    var footerNum = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref, ref1;
    var footerConfig = componentsList === null || componentsList === void 0 ? void 0 : (ref = componentsList.Footer) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.config;
    var shouldHideDSLabel = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.hide_ds_label;
    if (!shouldHideDSLabel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Powered by \xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://download.digitalshowroom.app/download-cfe",
                    target: "_blank",
                    className: "underline copyright-text-grey-color",
                    rel: "website app link noreferrer",
                    children: "DIGITAL SHOWROOM APP"
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 56695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DesignSystem_SubscriberInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/actions/leadgen.js
var leadgen = __webpack_require__(171);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/assets/svgExports/ForwardArrow.js

var ForwardArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.031",
        height: "16.031",
        viewBox: "0 0 16.031 16.031",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Path_49",
            "data-name": "Path 49",
            d: "M-3.984-12.984H-16.172l5.578-5.625L-12-20.016-20.016-12-12-3.984l1.406-1.406-5.578-5.625H-3.984Z",
            transform: "translate(-3.984 -3.984) rotate(180)",
            fill: "#fff"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(74943);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/validateEmailError.js
var validateEmailError = __webpack_require__(95288);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(99375);
;// CONCATENATED MODULE: ./src/components/DesignSystem/SubscriberInput/index.js










var SubscriberInput = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store,
            leadgenInfo: state.leadGenReducer.leadgenInfo,
            userData: state.userReducer.data
        };
    }), leadgenInfo = ref5.leadgenInfo, userData = ref5.userData, store = ref5.store;
    var ref6 = (0,react.useState)(""), sColor = ref6[0], setColor = ref6[1];
    var ref7 = (0,react.useState)(""), leadInput = ref7[0], setLeadInput = ref7[1];
    var ref8 = (0,react.useState)(false), leadError = ref8[0], setLeadError = ref8[1];
    var ref9 = (0,react.useState)(false), isSubmitInTransit = ref9[0], setIsSubmitInTransit = ref9[1];
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setColor((store === null || store === void 0 ? void 0 : store.premium) ? store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
    ]);
    var handleLeadInput = function(e) {
        var ref;
        var value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && value.length <= 10 || (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL) setLeadInput(value);
    };
    var submitLeadInput = function() {
        setIsSubmitInTransit(true);
        var phoneReg = /(6|7|8|9)\d{9}/;
        var emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var payload = {
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            lead_user_phone: "",
            lead_email_id: "",
            user_phone: userData === null || userData === void 0 ? void 0 : userData.phone
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE) payload["lead_user_phone"] = leadInput;
        else payload["lead_email_id"] = leadInput;
        if (payload["lead_email_id"]) {
            var status = (0,validateEmailError/* validateEmailError */.n)(payload["lead_email_id"]);
            if (!status) {
                return;
            }
        }
        var callback = function() {
            (0,Toast/* toastNotifySuccess */.jh)("Thanks for subscribing!");
            (0,localStorageFunctions/* setLeadData */.co)(leadInput);
            setLeadInput("");
            setTimeout(function() {
                return setIsSubmitInTransit(false);
            }, 500);
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && leadInput.length === 10 && leadInput.match(phoneReg)) {
            dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        } else if (leadInput.match(emailReg)) dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        else setLeadError(true);
    };
    var renderError = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "error-msg flex f7 red flex justify-start items-center mt2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ba b--red flex justify-center items-center br-pill bg-red white mr2 error-icon",
                    style: {
                        fontSize: 8,
                        padding: "2px 6px"
                    },
                    children: [
                        " ",
                        "!",
                        " "
                    ]
                }),
                "Please enter a valid ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email ID" : "phone number")
            ]
        });
    };
    return !!storePhone && (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.status) && !(0,localStorageFunctions/* getLeadData */.X5)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f6 mb2",
                children: "Subscribe for latest updates & offers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-start items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        placeholder: "Enter ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "Email" : "Phone Number"),
                        value: leadInput,
                        className: "f6 bg-white pv2 ph2 b--black-10 w-100 rm-input-num-arrows",
                        onChange: handleLeadInput,
                        type: "".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email" : "number")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "bn pointer",
                        "aria-label": "Subscribe for latest offers",
                        style: {
                            backgroundColor: "".concat(sColor || (store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color)),
                            borderRadius: "0px 4px 4px 0px",
                            padding: "9px 12px 8px 12px"
                        },
                        onClick: submitLeadInput,
                        disabled: isSubmitInTransit,
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {
                                color: "#0000000"
                            })
                        ]
                    })
                ]
            }),
            leadError ? renderError() : null
        ]
    }) : null;
};
/* harmony default export */ var DesignSystem_SubscriberInput = (SubscriberInput);


/***/ }),

/***/ 1218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48729);
/* harmony import */ var _utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48863);




function FooterMap2(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData, _height = props.height, height = _height === void 0 ? "250" : _height;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Footer2__section",
        ref: containerRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "100%",
            height: height,
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,_utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__/* .getGoogleMapUrl */ .D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FooterMap2, _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 76364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sy": function() { return /* reexport */ FooterMap_FooterMap; },
  "oJ": function() { return /* reexport */ FooterMap2/* default */.Z; },
  "IA": function() { return /* reexport */ FooterMap_FooterMap3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FooterMap/util/arePropsEqual.js
var arePropsEqual = __webpack_require__(48729);
// EXTERNAL MODULE: ./src/utils/getGoogleMapUrl.js
var getGoogleMapUrl = __webpack_require__(48863);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap.js




var FooterMap = /*#__PURE__*/ react.memo(function FooterMap(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData;
    var ref5 = (0,react.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        style: {
            display: "flex",
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            width: "100%",
            height: "250",
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}, arePropsEqual/* default */.Z);
/* harmony default export */ var FooterMap_FooterMap = (FooterMap);

// EXTERNAL MODULE: ./src/components/FooterMap/FooterMap2.js
var FooterMap2 = __webpack_require__(1218);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap3.js





function FooterMap3(props) {
    var _storeData = props.storeData, storeData = _storeData === void 0 ? {} : _storeData;
    var _address = storeData.address, address = _address === void 0 ? {} : _address;
    var ref = (0,react.useState)(false), loadMap = ref[0], setLoadMap = ref[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    var addressVisibilityHidden = function(visibilityValue) {
        return (address === null || address === void 0 ? void 0 : address.visibility) === visibilityValue;
    };
    var onHover = function() {
        document.getElementById("mapFrame").style.filter = "brightness(100%)";
        document.getElementById("mapText").style.display = "none";
    };
    var onHoverLeave = function() {
        document.getElementById("mapFrame").style.filter = "brightness(40%)";
        document.getElementById("mapText").style.display = "block";
    };
    return addressVisibilityHidden(constants/* ADDRESS_VISIBILITY.VISIBLE */.lE.VISIBLE) && !!address && !!(address === null || address === void 0 ? void 0 : address.latitude) && !!(address === null || address === void 0 ? void 0 : address.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: containerRef,
        className: "Footer3__map-section",
        onMouseEnter: onHover,
        onMouseLeave: onHoverLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                loading: "lazy",
                className: "map-frame",
                id: "mapFrame",
                width: "100%",
                height: "300px",
                title: "Address",
                src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(address === null || address === void 0 ? void 0 : address.latitude, address === null || address === void 0 ? void 0 : address.longitude) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "map-text",
                id: "mapText",
                children: "Find us here"
            })
        ]
    });
}
/* harmony default export */ var FooterMap_FooterMap3 = (/*#__PURE__*/react.memo(FooterMap3, arePropsEqual/* default */.Z));

;// CONCATENATED MODULE: ./src/components/FooterMap/index.js





/***/ }),

/***/ 48729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ arePropsEqual; }
/* harmony export */ });
function arePropsEqual(prevProps, nextProps) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return ((ref = prevProps.storeData) === null || ref === void 0 ? void 0 : ref.address) === ((ref1 = nextProps.storeData) === null || ref1 === void 0 ? void 0 : ref1.address) && ((ref2 = prevProps.storeData) === null || ref2 === void 0 ? void 0 : ref2.latitude) === ((ref3 = nextProps.storeData) === null || ref3 === void 0 ? void 0 : ref3.latitude) && ((ref4 = prevProps.storeData) === null || ref4 === void 0 ? void 0 : ref4.longitude) === ((ref5 = nextProps.storeData) === null || ref5 === void 0 ? void 0 : ref5.longitude);
}


/***/ }),

/***/ 73323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68037);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73494);


/**
 * use this hook to get info about store logo and store name visibility in Header and Footer.
 * visibility is defined by merchant by using editor.
 */ var useStoreLogoOrNameVisibility = function() {
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store.theme || {};
    }), _store_logo_status = ref.store_logo_status, store_logo_status = _store_logo_status === void 0 ? false : _store_logo_status, _store_name_status = ref.store_name_status, store_name_status = _store_name_status === void 0 ? false : _store_name_status;
    return {
        isStoreLogoInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_logo_status),
        isStoreLogoInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_logo_status),
        isStoreNameInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_name_status),
        isStoreNameInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_name_status)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreLogoOrNameVisibility);


/***/ }),

/***/ 20949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 13605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ commonToggleAuthModal; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44541);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * common function to initiate auth toggle
 * @param {*} param0
 * @return {boolean} return
 */ var commonToggleAuthModal = function(param) {
    var userLogin = param.userLogin, storeInfoDomain = param.storeInfoDomain;
    if (userLogin) {
        return true;
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_0__.PATH.ORDERS, storeInfoDomain));
    }
    return false;
};


/***/ }),

/***/ 68491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 48863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getGoogleMapUrl; }
/* harmony export */ });
var getGoogleMapUrl = function(latitude, longitude) {
    return "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAVC1rp28LPP-kwCwVPZpZEt5LqLNYXVS8", "&q=").concat(latitude, ",").concat(longitude);
};


/***/ }),

/***/ 79570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56714);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ }),

/***/ 53569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ commonOutsideClick; },
/* harmony export */   "W": function() { return /* binding */ isOutsideClick; }
/* harmony export */ });
var isOutsideClick = function(parentRef, target) {
    var ref;
    if ((ref = parentRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) return true;
    return false;
};
var commonOutsideClick = function(param) {
    var event = param.event, _pathNo = param.pathNo, pathNo = _pathNo === void 0 ? 0 : _pathNo, ref = param.ref, callback = param.callback;
    var path = event.path || event.composedPath && event.composedPath();
    if (!isOutsideClick(ref, path[pathNo])) {
        callback && callback();
    }
};


/***/ }),

/***/ 73494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ }),

/***/ 95288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ validateEmailError; }
/* harmony export */ });
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40804);

function validateEmailError(mail) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
        (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyError */ .Lu)("Invalid Email Id");
        return false;
    }
    return true;
}


/***/ })

}]);